var _rect, _rect2, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCanvasEventThreads(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 101,
    viewBox: "0 0 100 101",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100,
    rx: 50,
    transform: "matrix(-4.37114e-08 1 -1 -1.05524e-06 100 0.55835)",
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 20,
    y: 20.5583,
    width: 60,
    height: 59.9999,
    rx: 30,
    fill: "#121212"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M59.0178 48.8487C58.7073 43.1236 55.5793 39.8461 50.3276 39.8135C47.1613 39.7943 44.5144 41.136 42.8929 43.5951L45.7832 45.575C46.9984 43.7331 48.917 43.3517 50.3065 43.3651C52.0373 43.3766 53.3406 43.8788 54.1859 44.8601C54.7992 45.5731 55.2113 46.5602 55.4164 47.8041C53.883 47.5434 52.2232 47.4629 50.4522 47.5645C45.4574 47.852 42.2489 50.7653 42.4635 54.8114C42.5728 56.8642 43.5944 58.6313 45.3424 59.7852C46.8182 60.7608 48.7234 61.2361 50.6995 61.1288C53.3119 60.985 55.3608 59.9903 56.7906 58.1675C57.8755 56.7837 58.5616 54.9897 58.8645 52.7318C60.1103 53.4832 61.0303 54.4703 61.542 55.6586C62.4084 57.6788 62.4582 60.9984 59.75 63.7048C57.3771 66.0738 54.5251 67.1011 50.2145 67.1318C45.4325 67.0973 41.8157 65.562 39.4659 62.5739C37.2617 59.7756 36.1251 55.7314 36.083 50.5583C36.1251 45.3833 37.2636 41.3411 39.4659 38.5408C41.8157 35.5528 45.4325 34.0194 50.2145 33.9849C55.0311 34.0213 58.7092 35.5604 61.151 38.5658C62.349 40.0378 63.2498 41.8893 63.8459 44.0474L67.2307 43.1466C66.5081 40.4882 65.3735 38.1978 63.8305 36.2983C60.7006 32.4458 56.1006 30.4736 50.203 30.4333C44.317 30.4736 39.7917 32.4554 36.75 36.3194C34.0455 39.7598 32.6483 44.5726 32.6023 50.5718C32.6483 56.5709 34.0455 61.3569 36.75 64.7973C39.7917 68.6613 44.34 70.6431 50.2241 70.6833C55.4585 70.6469 59.1462 69.2765 62.1841 66.2424C66.1612 62.2692 66.0405 57.2916 64.7314 54.2364C63.7251 51.8885 61.7222 50.0083 59.0197 48.8506M50.5135 57.5849C48.3247 57.7075 46.0515 56.7262 45.9385 54.6217C45.856 53.0615 47.0501 51.3212 50.6477 51.1142C52.2737 51.005 53.9069 51.1172 55.5026 51.4477C55.0886 56.6265 52.6564 57.466 50.5135 57.5849Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCanvasEventThreads);
export default __webpack_public_path__ + "static/media/canvas_event_threads.4497199c2f5e4736a8f34db7320168e9.svg";
export { ForwardRef as ReactComponent };